module.exports = __webpack_public_path__ + "img/2025-09-19d_7.9c7df625.jpg";